import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, Platform, LoadingController } from 'ionic-angular';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the B09InventoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface branchInfo{
  BRANCH_ID: number;
};

interface inventoryInfo{
  INVENTORY_ID: number;
  SELLING_PRICE: number;
  newPrice: number;
};

@IonicPage()
@Component({
  selector: 'page-b09-inventory',
  templateUrl: 'b09-inventory.html',
})
export class B09InventoryPage {

  loading: any;
  Status: any;
  public errorMessage: any = "";
  branchID: any;
  GRP_ID: any;

  //BRANCH
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  branchData=[];
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  inventoryData= [];

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private alertController:AlertController, public serviceapi:ServiceApiProvider, public loadingCtrl: LoadingController,
              public servicegvariable:ServiceGvariableProvider, public platform: Platform, public storage: Storage) {

    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.showLoader();
      this.storage.get('offlineBranchData').then((data) => {
      this.branchID = data;
      this.storage.get('branchData').then((data) => {
        this.branchData = data;
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
            let data = JSON.parse(this.branchData[i]);
            for (let i=0; i<data.length; i++){
              if (this.branchID == data[i].BRANCH_ID){
                this.branchArr.push(data[i]);
              }
            }
          }
          this.branchItems = this.branchArr;

          this.storage.get('inventoryData').then((data) => {
            this.inventoryData = data;
            if (data && data.length > 0) {
              for (let i=0; i<data.length; i++){
                  
                let data = JSON.parse(this.inventoryData[i]);
                for (let i=0; i<data.length; i++){
                  if (this.branchID == data[i].BRANCH_ID){
                    this.inventoryArr.push(data[i]);

                  }
                }
              }
    
              console.log(this.inventoryArr)
              this.inventoryItems = this.inventoryArr;
              this.loading.dismiss();
            }
          });
        }
      });
    }); 
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B09InventoryPage');
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });

    this.loading.present();
  }

  save(){

    let length= this.inventoryItems.length;

    for (let i=0; i<length; i++){
      if (this.inventoryItems[i].newPrice != null){
        this.inventoryItems[i].SELLING_PRICE = this.inventoryItems[i].newPrice;
        this.inventoryItems[i].newPrice = null;
      }
    }

    this.inventoryArr = this.inventoryItems;
    let val2 = JSON.stringify(this.inventoryArr);
    this.storage.get('inventoryData').then((data) => {
      let array = [];
      array.push(val2);
      this.storage.set('inventoryData', array);                   //store arr arr
    });

  }

  cancel(){
    let length= this.inventoryItems.length;

    for (let i=0; i<length; i++){
      this.inventoryItems[i].newPrice = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/b09-inventory/b09-inventory.ts